import { render, staticRenderFns } from "./annotation-selection.vue?vue&type=template&id=674e8206&"
import script from "./annotation-selection.vue?vue&type=script&lang=js&"
export * from "./annotation-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports